// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#default-test-preview .el-dialog {\n  width: 60% !important;\n  margin-top: 7vh;\n}\n.default-modal .respiratory-checkbox .popup-panels-blocks .check-list-check-list-default {\n  grid-template-columns: repeat(2, 1fr);\n}\n.default-modal .respiratory-checkbox .popup-panels-blocks .el-checkbox__label {\n  color: #34495e;\n  white-space: pre-wrap;\n}", ""]);
// Exports
module.exports = exports;
